<template>
  <div id="app">
    <!-- <img src="./assets/logo.png">
    <HelloWorld/>
    <Test/> -->



    <!-- 頭部 -->
    <MyHeader :poiInfo='poiInfo'></MyHeader>
    <!-- 導航 -->
    <MyNav :commentNum="commentNum"></MyNav>
    <!-- 主體內容 -->


    <keep-alive>
        <!-- 路由出口 -->
        <!-- 路由匹配到的组件将渲染在这里 -->
        <router-view></router-view>
    </keep-alive>
    <!-- 在這裡加入keep-alive可以達成免除用戶在路由切換的
    時候重複載入組建的問題 -->


  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld'
// import Test from './components/Test.vue'

// export default {
//   name: 'App',
//   components: {
//     HelloWorld,
//     Test
//   }
// }

//1、導入
import MyHeader from './components/header/Header'
import MyNav from './components/nav/Nav'
import MyContent from './components/content/Content'

export default {
  name: 'App',
  components: {
    //2、註冊
    MyHeader,MyNav,MyContent
  },
  data () {
    return{
      //header組件需要的訊息(商家訊息)
      poiInfo:{},
      commentNum: 0,
    }
  },
  created () {    //發起異步請求，獲取資料

      var that =  this

    //通過axios發起get請求
      this.$axios.get('/api/goods')
    .then(function (response) {   //獲取數據
      // handle success
      // console.log(response)
      var dataSource = response.data.data

        // console.log(dataSource)

      // console.log(dataSource.data.data.poi_info);
      if (dataSource.code == 0){
        // that.poiInfo = dataSource.data.poi_info
        that.poiInfo = dataSource.data.poi_info

        // console.log(that.poiInfo)

        // console.log(dataSource)
      }
    })
    .catch(function (error) {   //出錯處理
      // handle error
      console.log(error)
    })





    //---------------20211011-----------------------


    //通過axios發起get請求
      this.$axios.get('/api/ratings')
    .then(function (response) {   //獲取數據
      var dataSource = response.data.data
      if (dataSource.code == 0){
        that.commentNum = dataSource.data.comment_num

        // console.log(this.commentNum)
      }
    })
    .catch(function (error) {   //出錯處理
      // handle error
      console.log(error)
    })


    //--------------------------------------



  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue